// extracted by mini-css-extract-plugin
export default {"root":"_1ywNy5hJ","link":"_1aIMptGt","slideDown":"_2_hPEiJp","animated":"_1qeOWlDh","text":"_35B-32pk","decorateText":"_25CXFhmE"};